import React from "react";
import Solidworks1 from "../assets/img/pageimages/Solidworks1.jpeg";
import Solidworks2 from "../assets/img/pageimages/Solidworks2.jpeg";
import Solidworks3 from "../assets/img/pageimages/Solidworks3.jpeg";

const Solidworks = () => {
  return (
    <div className="solidworks-wrapper">
      <style>{`
        .solidworks-wrapper {
          background-color: #f9fafb;
          padding: 4rem 1rem;
          font-family: 'Poppins', sans-serif;
        }

        .solidworks-header {
          text-align: center;
          margin-bottom: 4rem;
        }

        .solidworks-header h1 {
          color: #7620ff;
          font-weight: bold;
          margin-bottom: 1rem;
        }

        .solidworks-header p {
          margin: 0 auto;
          max-width:80%;
        }

        .solidworks-gallery {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 1.5rem;
          max-width: 1100px;
          margin: 0 auto 4rem;
        }

        .solidworks-gallery img {
          width: 100%;
          height: 260px;
          object-fit: cover;
          border-radius: 1rem;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          transition: transform 0.3s ease;
        }

        .info-box {
          background: white;
          border-radius: 1rem;
          box-shadow: 0 4px 14px rgba(0, 0, 0, 0.05);
          padding: 2rem;
          max-width: 80%;
          margin: 0 auto 4rem;
          text-align: center;
        }

        .info-box h2 {
          color: #fdba00;
          margin-bottom: 1rem;
        }

        .features-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 2rem;
          max-width: 1100px;
          margin: 0 auto 4rem;
        }

        .features-grid .box {
          background: white;
          border-radius: 1rem;
          padding: 2rem;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
        }

        .features-grid h3 {
          margin-bottom: 1rem;
          color:  #fdba00;
        }

        .features-grid ul {
          padding-left: 1.25rem;
          color: #374151;
        }

        .learn-more {
          text-align: center;
          margin-bottom: 3rem;
        }

        .learn-more h2 {
          color: #fdba00;
          margin-bottom: 1rem;
        }

        .learn-more a {
          display: inline-block;
          margin: 0.5rem;
          padding: 1rem 2rem;
          background: #dbeafe;
          color: #1d4ed8;
          border-radius: 0.75rem;
          font-weight: 600;
          text-decoration: none;
          transition: background 0.3s ease;
        }

        .learn-more a:hover {
          background: #bfdbfe;
        }
      `}</style>

      {/* Header Section */}
      <header className="solidworks-header">
        <h1 style={{ marginTop: "3rem" }}>SolidWorks Services</h1>
        <p>
          SOLIDWORKS is a powerful 3D CAD and CAE software developed by Dassault
          Systèmes. It's widely used in design, engineering, and manufacturing
          industries across the globe.
        </p>
      </header>

      {/* Image Section */}
      <section className="solidworks-gallery">
        {[Solidworks1, Solidworks2, Solidworks3].map((img, index) => (
          <img key={index} src={img} alt={`SolidWorks Showcase ${index + 1}`} />
        ))}
      </section>

      {/* What is SolidWorks */}
      <section className="info-box">
        <h2>What is SolidWorks?</h2>
        <p>
          SOLIDWORKS is parametric 3D CAD software. Users can edit models by
          adjusting parameters instead of starting from scratch. This ensures design
          consistency and efficient iterations.
        </p>
      </section>

      {/* Features & Applications */}
      <section className="features-grid">
        <div className="box">
          <h3>Key Features</h3>
          <ul>
            <li>3D modeling & parametric design</li>
            <li>Assembly design & detailing</li>
            <li>Simulations & stress analysis</li>
            <li>Electrical & piping systems support</li>
            <li>Advanced rendering & visualization</li>
          </ul>
        </div>
        <div className="box">
          <h3>Applications & Integration</h3>
          <ul>
            <li>Used in industrial, medical, and consumer products</li>
            <li>Streamlines manufacturing and development</li>
            <li>Improves collaboration across teams</li>
            <li>Integrates with 3DEXPERIENCE platform</li>
            <li>Reduces time-to-market and boosts productivity</li>
          </ul>
        </div>
      </section>

      {/* Learn More */}
      <section className="learn-more">
        <h2>Learn More About SolidWorks</h2>
        <a
          href="https://www.solidworks.com/sw/resources/getting-started.htm"
          target="_blank"
          rel="noopener noreferrer"
        >
          Getting Started with SolidWorks
        </a>
        <a
          href="https://www.solidworks.com/sw/resources/solidworks-tutorials.htm"
          target="_blank"
          rel="noopener noreferrer"
        >
          SolidWorks Tutorials
        </a>
      </section>
    </div>
  );
};

export default Solidworks;
